export type Season = "Spring" | "Summer" | "Autumn" | "Winter";

export const SEASONS: readonly Season[] = [
  "Spring",
  "Summer",
  "Autumn",
  "Winter",
] as const;

export interface ClockState {
  year: number;
  seasonIndex: number; // 0..3
  turn: number; // total turns advanced (0 at start)
}

export function createClock(year = 1, seasonIndex = 0): ClockState {
  return {
    year: Math.max(1, year | 0),
    seasonIndex: ((seasonIndex % 4) + 4) % 4,
    turn: 0,
  };
}

export function seasonOf(clock: ClockState): Season {
  return SEASONS[clock.seasonIndex]!;
}

/** Advance one season. Winter → Spring bumps year. */
export function advanceSeason(clock: ClockState): ClockState {
  const nextIndex = clock.seasonIndex + 1;
  if (nextIndex >= 4) {
    return {
      year: clock.year + 1,
      seasonIndex: 0,
      turn: clock.turn + 1,
    };
  }
  return {
    year: clock.year,
    seasonIndex: nextIndex,
    turn: clock.turn + 1,
  };
}

/** Season chrome hooks (loud, visible). Numbers stubbed for Phase 1. */
export interface SeasonHook {
  id: string;
  label: string;
  detail: string;
}

export function seasonHooks(season: Season): [SeasonHook, SeasonHook] {
  switch (season) {
    case "Spring":
      return [
        {
          id: "flood",
          label: "Spring floods",
          detail: "Rivers block troop movement unless bridged (3.5).",
        },
        {
          id: "planting",
          label: "Planting",
          detail: "Food stores lean until harvest; claim tiles feed the seat.",
        },
      ];
    case "Summer":
      return [
        {
          id: "campaign",
          label: "Campaign season",
          detail: "Long days favor travel and war (stub).",
        },
        {
          id: "growth",
          label: "Fields fatten",
          detail: "Wood and food tick up easier (stub).",
        },
      ];
    case "Autumn":
      return [
        {
          id: "harvest",
          label: "Harvest",
          detail: "Fill granaries before the freeze (stub).",
        },
        {
          id: "tithe",
          label: "Tithe reckoning",
          detail: "Gold and loyalty settle (stub).",
        },
      ];
    case "Winter":
      return [
        {
          id: "freeze",
          label: "Deep freeze",
          detail: "Home-range moves lean; greed starves (stub).",
        },
        {
          id: "hearth",
          label: "Hearth tax",
          detail: "Food upkeep bites hard (stub).",
        },
      ];
  }
}
